import { useLocation } from 'react-router-dom';
import TopNavBar from './TopNavBar';
import BottomBar from './BottomBar';
import CrmSubNav from './CrmSubNav';
import OperationsSubNav from './OperationsSubNav';
import { ScanModal } from '@/components/scan/ScanModal';
import TourChoiceDialog from '@/components/tour/TourChoiceDialog';


interface AppLayoutProps {
  children: React.ReactNode;
}

const OPS_PREFIXES = ['/dashboard', '/work-orders', '/containers', '/assets'];

export default function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();
  const isCrmRoute = location.pathname === '/crm' || location.pathname.startsWith('/crm/');
  const isOpsRoute = OPS_PREFIXES.some((p) => location.pathname === p || location.pathname.startsWith(p + '/'));

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <TopNavBar />
      {isOpsRoute && <OperationsSubNav />}
      {isCrmRoute && <CrmSubNav />}
      <main className="flex-1 overflow-y-auto p-4 pb-20 md:p-6 md:pb-6">
        {children}
      </main>
      <BottomBar />
      <ScanModal />
      <TourChoiceDialog />
      
    </div>
  );
}
